import React, { useState, useRef, useEffect } from "react";
import Icons from "../../icons";
import Modal from "../../common/modal";
import "./searchDevice.scss";
import ModalComponent from "../modalComponent/ModalComponent";
import { useTranslation } from "react-i18next";

const SearchDevice = ({
  onClose,
  // resetSelection,
  defaultSelection = false,
  selectedId,
  allDevices = [],
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [deviceNames, setDeviceNames] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValue, setSelectedValue] = useState();
  const [dropdownValues, setdropdownValues] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [searchFailureModal, setSearchFailureModal] = useState(false);

  const dropdownRef = useRef(null);
  const searchRef = useRef(null);
  const dropdownValuesRef = useRef(null);

  const { t } = useTranslation("searchDevice");

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleValueSelect = (event, value) => {
    event.stopPropagation();
    setSelectedValue(value);
    setSearchTerm("");
    setIsExpanded(false);
    onClose(value.id);
  };

  const handleDropdownToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleDocumentClick = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      searchRef.current &&
      !searchRef.current.contains(event.target)
    ) {
      setIsExpanded(false);
      setSearchTerm("");
    }
  };

  useEffect(() => {
    if (dropdownValues?.length) {
      const updatedFilteredValues = dropdownValues
        .filter((value) =>
          value?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())
        )
        .sort();
      setFilteredValues(updatedFilteredValues);
    }
  }, [dropdownValues, searchTerm]);

  const isNoResults = searchTerm && !filteredValues?.length;

  const handleCancelSearch = (event) => {
    event.stopPropagation();
    setSearchTerm("");
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  useEffect(() => {
    setDeviceNames(allDevices);
    if (defaultSelection) {
      if (selectedId) {
        const data = allDevices.find(
          (device) => device.DeviceUUID === selectedId
        );
        setSelectedValue({
          name: data.DeviceName,
          id: data.DeviceUUID,
        });
      } else {
        setSelectedValue({
          name: allDevices[0].DeviceName,
          id: allDevices[0].DeviceUUID,
        });
      }
    } else {
      setSelectedValue();
      // resetSelection();
    }
  }, [allDevices, defaultSelection, selectedId]);

  useEffect(() => {
    if (deviceNames?.length) {
      setdropdownValues(
        deviceNames.map((device) => {
          return { name: device.DeviceName, id: device.DeviceUUID };
        })
      );
    }
  }, [deviceNames]);

  return (
    <div className="dropdownSelectMainContaianer" ref={dropdownRef}>
      <div
        className={`selectContainer ${isExpanded ? "expanded" : ""}`}
        onClick={() => {
          handleDropdownToggle();
        }}
      >
        <div>
          {selectedValue ? (
            <div className="deviceSelectedDeviceContainer">
              {Icons.deviceListIcon}
              <span id="selectedDeviceName">{selectedValue.name}</span>
            </div>
          ) : (
            <span id="selectText">Select a device</span>
          )}
        </div>

        {isExpanded ? (
          <div>{Icons.chevronUpArrowIcon}</div>
        ) : (
          <div>{Icons.downArrowOutlineIcon}</div>
        )}
      </div>
      <div>
        {isExpanded && (
          <div className="dropdown-values">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search a device"
                className="search-input"
                id="searchInputBox"
                value={searchTerm}
                ref={searchRef}
                onChange={handleSearchChange}
              />

              {searchTerm ? (
                <span className="cancel-icon" onClick={handleCancelSearch}>
                  X
                </span>
              ) : (
                <div className="search-icon" id="searchIcon">
                  {Icons.searchIcon}
                </div>
              )}
            </div>
            {!defaultSelection && (
              <p className="noSelectionText">
                ------------------No Selection------------------
              </p>
            )}
            {isNoResults ? (
              <p className="no-results" id="noResultsFound">
                No Results Found
              </p>
            ) : (
              <ul className="dropdownListValues" ref={dropdownValuesRef}>
                {filteredValues && (
                  <>
                    {filteredValues.map((value, index) => (
                      <li
                        key={index}
                        onClick={(event) => handleValueSelect(event, value)}
                        title={value.name}
                      >
                        <div className="deviceIconNameContainer">
                          {Icons.deviceListIcon}
                          <span id="deviceIconNameList">{value.name}</span>
                        </div>
                      </li>
                    ))}
                  </>
                )}
              </ul>
            )}
          </div>
        )}
      </div>

      <ModalComponent
        idName="search_modal"
        isOpen={searchFailureModal}
        onCloseModal={() => setSearchFailureModal(false)}
        descriptionText={t("search_failure_message")}
      ></ModalComponent>
    </div>
  );
};

export default SearchDevice;
